import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';

/* Actions */
import { SetData, ResetAppData, UpdateUserAccount } from './app.action';

/* Services */
import { AuthService } from 'src/app/core/services/auth.service';

/* Models */
import { Customer } from '../../models/customer.model';
import { User } from '../../models/user.model';

/* Models */
import { AppStateModel, initialState, StaticData } from './app.model';

type LocalStateContext = StateContext<AppStateModel>;

@State<AppStateModel>({
	name: 'appState',
	defaults: initialState,
})
@Injectable()
export class AppState {
	constructor(private authService: AuthService, private router: Router, private store: Store) {}

	@Selector()
	static staticData(state: AppStateModel): StaticData {
		return state.staticData;
	}
	@Selector()
	static user(state: AppStateModel): User {
		return state.user;
	}
	@Selector()
	static customer(state: AppStateModel): Customer {
		return state.customer;
	}

	@Action(SetData)
	setData({ patchState }: LocalStateContext, action: SetData) {
		const { data } = action;
		patchState({
			user: data.user,
			customer: data.customer,
			staticData: {
				dataTypes: data.dataTypes,
				nodeTypes: data.nodeTypes,
				assets: data.assets,
				references: data.references,
				nodes: data.nodes,
			},
		});
	}

	@Action(UpdateUserAccount, { cancelUncompleted: true })
	async updateUserAccount({ patchState }: LocalStateContext, action: UpdateUserAccount): Promise<void> {
		const { field, value, dataType } = action;
		try {
			const updatedData = await this.authService.updateUserAccount({ field, value, dataType }).toPromise();
			patchState({ [dataType]: updatedData });
		} catch (error) {
			console.log('error updating user account', error);
		}
	}

	@Action(ResetAppData)
	async resetData({ setState }: LocalStateContext): Promise<void> {
		await this.router.navigateByUrl('/login');
		setState(initialState);
	}
}
